// @ts-ignore

import { css } from '@compiled/react';
import { useIntl } from 'react-intl';

import { wacToken } from '@/libraries/design/foundations';
import { useLocalizedHref } from '@/libraries/web-framework/src/localization/use-localized-href';
import { Row } from '@/libraries/wpl/foundations/src/grid';
import { LogoV3 } from '@/libraries/wpl/foundations/src/logo-v3';

import { TryPageCard } from '../../components/try-page-card';
import { TryPageHeader } from '../../components/try-page-header';
import { messages } from '../messages';

const sectionStyles = css({
	padding: '64px 0 32px',
	position: 'relative',
	verticalAlign: 'baseline',
	marginInlineEnd: 'auto',
	marginInlineStart: 'auto',
	minWidth: '100%',
});

const PlanAndTrackSection = () => {
	const intl = useIntl();

	const jiraSofttwareHeaderText = intl.formatMessage({
		id: 'TryPageTemplate.PlanAndTrack.title',
		defaultMessage: 'Plan & Track',
	});
	const headerProps = {
		headerText: jiraSofttwareHeaderText,
		dividerColor: wacToken('color.primary.blue'),
	};

	const jiraSofttwareBodyText = intl.formatMessage({
		id: 'TryPageTemplate.PlanAndTrack.jiraBody',
		defaultMessage:
			'Friendly and intuitive collaboration for business teams and their projects, built for cross-team coordination and breaking down silos.',
	});
	const jiraSofttwareLink = useLocalizedHref('/try/cloud/signup?bundle=jira-software&edition=free');

	const jirProductDiscoveryBodyText = intl.formatMessage({
		id: 'TryPageTemplate.PlanAndTrack.jirProductDiscoveryBody',
		defaultMessage:
			'Organize and prioritize ideas, share product roadmaps, and connect business and tech teams, all in Jira.',
	});
	const jirProductDiscoveryLink = useLocalizedHref(
		'/try/cloud/signup?bundle=jira-product-discovery',
	);

	const tryCloud = intl.formatMessage(messages.tryCloud);
	const jiraLogo = <LogoV3 brand={'jira'} type="logo" appearance="brand" />;
	const jpdLogo = <LogoV3 brand={'jiraproductdiscovery'} type="logo" appearance="brand" />;

	const jiracardProps = {
		logo: jiraLogo,
		link: jiraSofttwareLink,
		bodyText: jiraSofttwareBodyText,
		ctaText: tryCloud,
	};
	const jpdcardProps = {
		logo: jpdLogo,
		link: jirProductDiscoveryLink,
		bodyText: jirProductDiscoveryBodyText,
		ctaText: tryCloud,
	};
	return (
		<div css={sectionStyles}>
			<Row>
				<TryPageHeader {...headerProps} />
			</Row>
			<Row layout="6-6">
				<TryPageCard {...jiracardProps} />
				<TryPageCard {...jpdcardProps} />
			</Row>
		</div>
	);
};

export default PlanAndTrackSection;
